"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDetail = getDetail;
exports.listCc = listCc;
exports.listMine = listMine;
exports.markCcRead = markCcRead;
exports.urge = urge;
exports.withdraw = withdraw;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 商户端审批 API - 直连 tjMall-flowable 服务
 */

// 兜底地址与当前部署网关保持一致。
// 页面上只表现为审批列表一直转圈，看不出是配置漏了
var baseURL = process.env.VUE_APP_FLOWABLE_API || 'http://192.168.3.81:8909/flowable';

// 我发起的审批
function listMine(userId) {
  return (0, _request.default)({
    url: '/flowable/approval/mine/list',
    method: 'get',
    params: {
      userId: userId
    },
    baseURL: baseURL
  });
}

// 审批详情 (含操作历史)
function getDetail(instanceId) {
  return (0, _request.default)({
    url: "/flowable/approval/detail/".concat(instanceId),
    method: 'get',
    baseURL: baseURL
  });
}

// 撤回
function withdraw(instanceId, userId) {
  return (0, _request.default)({
    url: "/flowable/approval/withdraw/".concat(instanceId),
    method: 'post',
    params: {
      userId: userId
    },
    baseURL: baseURL
  });
}

// 催办 (提醒当前审批人)
function urge(instanceId, userId) {
  return (0, _request.default)({
    url: "/flowable/approval/urge/".concat(instanceId),
    method: 'post',
    params: {
      userId: userId
    },
    baseURL: baseURL
  });
}

// 我收到的抄送
function listCc(userId) {
  return (0, _request.default)({
    url: '/flowable/approval/cc/list',
    method: 'get',
    params: {
      userId: userId
    },
    baseURL: baseURL
  });
}

// 标记抄送已读
function markCcRead(ccId, userId) {
  return (0, _request.default)({
    url: "/flowable/approval/cc/read/".concat(ccId),
    method: 'post',
    params: {
      userId: userId
    },
    baseURL: baseURL
  });
}